import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import LogoImage from "../assets/images/Logo-3.png";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  // Scroll detection for center menu (DESKTOP ONLY)
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const handleDownloadCV = () => {
    // 1. Open in new tab
    window.open("/Divyasri_Kandavalli_Resume.pdf", "_blank");

    // 2. Trigger download
    const link = document.createElement("a");
    link.href = "/Divyasri_Kandavalli_Resume.pdf";
    link.download = "Divyasri_Kandavalli_Resume.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const navHover = isScrolled ? "hover:text-[#163031]" : "hover:text-[#6cfcb5]";
  return (
    <>
      {/* ================= HEADER ================= */}
      {/* Mobile: sticky + bg */}
      {/* Desktop: normal (not sticky) */}
      <nav
        className="
        sticky top-0 z-50 bg-[#1f3d3b]
        lg:relative lg:bg-transparent lg:z-30
        py-3
      "
      >
        <div className="max-w-screen-xl mx-auto px-4 flex items-center justify-between">
          {/* LOGO */}
          <Link to="/" onClick={scrollToTop} className="flex items-center">
            <img src={LogoImage} alt="Logo" className="h-auto w-auto" />
          </Link>

          {/* HAMBURGER (MOBILE) */}
          <button
            onClick={toggleMenu}
            className="lg:hidden text-[#163031] bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] p-2 rounded-md"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              />
            </svg>
          </button>

          {/* DOWNLOAD BUTTON (DESKTOP ONLY) */}
          <div className="hidden lg:flex">
            <button
              onClick={handleDownloadCV}
              className="px-8 py-3 rounded-full font-semibold text-[#163031]
             bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C]
             hover:bg-gradient-to-l transition"
            >
              Download CV
            </button>
          </div>
        </div>
      </nav>

      {/* ================= CENTER FLOATING MENU (DESKTOP ONLY) ================= */}
      <div
        className={`hidden lg:flex justify-center transition-all duration-500
    ${
      isScrolled
        ? "fixed bottom-6 left-1/2 -translate-x-1/2 z-50"
        : "fixed top-6 left-1/2 -translate-x-1/2 z-40"
    }`}
      >
        <ul
          className={`flex items-center gap-6 px-8 py-3 rounded-full font-semibold shadow-lg transition-all duration-500
  ${
    isScrolled
      ? "bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] text-[#163031]"
      : "bg-[#1f3d3b]/90 backdrop-blur-md text-white"
  }`}
        >
          <button onClick={scrollToTop} className={`transition ${navHover}`}>
            Home
          </button>

          <button
            onClick={() => scrollToSection("about")}
            className={`transition ${navHover}`}
          >
            About
          </button>

          <button
            onClick={() => scrollToSection("skills")}
            className={`transition ${navHover}`}
          >
            Skills
          </button>

          <button
            onClick={() => scrollToSection("projects")}
            className={`transition ${navHover}`}
          >
            Projects
          </button>

          <button
            onClick={() => scrollToSection("contact")}
            className={`transition ${navHover}`}
          >
            Contact
          </button>
        </ul>
      </div>

      {/* ================= MOBILE FULL SCREEN MENU ================= */}
      <div
        className={`fixed top-0 left-0 w-full h-screen z-50 bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] transition-transform duration-300 lg:hidden ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex justify-end p-5">
          <button
            onClick={toggleMenu}
            className="bg-[#163031] text-white w-10 h-10 rounded-lg font-bold"
          >
            ✕
          </button>
        </div>

        <ul className="px-6 space-y-4 text-[#163031] font-semibold">
          <li>
            <button
              onClick={() => {
                scrollToTop();
                toggleMenu();
              }}
              className="block w-full text-left px-3  rounded-lg hover:bg-[#163031] hover:text-[#6cfcb5] transition"
            >
              Home
            </button>
          </li>

          <li>
            <button
              onClick={() => {
                scrollToSection("about");
                toggleMenu();
              }}
              className="block w-full text-left px-3  rounded-lg hover:bg-[#163031] hover:text-[#6cfcb5] transition"
            >
              About
            </button>
          </li>

          <li>
            <button
              onClick={() => {
                scrollToSection("skills");
                toggleMenu();
              }}
              className="block w-full text-left px-3  rounded-lg hover:bg-[#163031] hover:text-[#6cfcb5] transition"
            >
              Skills
            </button>
          </li>

          <li>
            <button
              onClick={() => {
                scrollToSection("projects");
                toggleMenu();
              }}
              className="block w-full text-left px-3  rounded-lg hover:bg-[#163031] hover:text-[#6cfcb5] transition"
            >
              Projects
            </button>
          </li>

          <li>
            <button
              onClick={() => {
                scrollToSection("contact");
                toggleMenu();
              }}
              className="block w-full text-left px-3  rounded-lg hover:bg-[#163031] hover:text-[#6cfcb5] transition"
            >
              Contact
            </button>
          </li>
        </ul>
      </div>
      {/* ================= RIGHT SIDE STICKY DOWNLOAD CV (DESKTOP ONLY) ================= */}
      {isScrolled && (
        <div className="hidden lg:flex fixed right-0 top-1/2 -translate-y-1/2 z-50">
          <button
            onClick={handleDownloadCV}
            className="
    bg-gradient-to-b from-[#6cfcb5] to-[#F0FF6C]
    text-[#163031]
    font-semibold
    px-4 py-6
    rounded-r-xl
    shadow-xl
    hover:scale-105
    transition-all duration-300
    flex items-center justify-center
  "
            style={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)",
            }}
          >
            Download CV
          </button>
        </div>
      )}
    </>
  );
}
